import React, { useState, useEffect, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Rating } from 'react-simple-star-rating';
import { useFetch } from '../../api/FetchApiData';
import { MediaUrl } from '../../utils/Media';
import { useInfiniteScroll } from '../../utils/InfiniteScroll';
import { UserContext } from '../../../AppContextProvider';
import { isMobile } from 'react-device-detect';
import orders_icon from '../../icons/orders.png';
import remove_icon from '../../icons/remove.png';
import fret_icon from '../../icons/fret.jpg';
import Popup from 'reactjs-popup';
import { Fret } from './Deliver.jsx';
import { DeliverOrders } from './Deliver.jsx';
if (isMobile)
    import('../partners/partners_mob.css').then(() => {});
else
    import('../partners/partners.css').then(() => {});

function DeliverFretsPopUp({deliver,close=[()=>{}]})
{
    const [pageFrets,setPageFrets] = useState({CurrentPage:1,MaxPage:1});
    const [hasMoreFrets,setHasMoreFrets] = useState(true);
    const [frets,setFrets] = useState([]);
    const fetchData = useFetch();
    let _margin = '100px auto auto auto';
    let _with = '60%';
    let _height = ''
    if(isMobile)
    {
        _margin = '80px auto auto auto';
        _with = '95%';
    }

    const FetchDeliverFrets = useCallback(async ()=>{ 
     
    if(!hasMoreFrets)
        return;
    if(pageFrets.CurrentPage<=pageFrets.MaxPage)
    {
        fetchData.GetData(`delivers/frets/${deliver.id}/1/${pageFrets.CurrentPage}/`).then((result)=>{
            if(result.result)
            {
                if(pageFrets.CurrentPage>result.maxpage)
                    setHasMoreFrets(false);
                else
                {setFrets([...frets,...result.items]);setPageFrets({...pageFrets,CurrentPage:pageFrets.CurrentPage+1,MaxPage:result.maxpage});}
            }
        })
    }
    },[pageFrets.CurrentPage,hasMoreFrets]);

    const LoadMoreFretsRef = useInfiniteScroll(FetchDeliverFrets,hasMoreFrets);

    return(
            <fieldset style={{position:'fixed',top:'0px',display:'flex',flexDirection:'column',left:'0px',marginLeft:'0px',padding:'0px',backgroundColor:'rgba(255,255,255,0.9)',width:'100%',height:'100vh'}}>
                <div style={{padding:'10px 0px 10px 0px',margin:_margin,marginBottom:'0px',backgroundColor:'white',position:'relative',border:'1px solid gray',borderRadius:'20px',width:_with,maxHeight:'80vh',overflowY:'auto'}}>
                    {frets.map((fret)=>{
                        return(
                            <Fret editable={false} fret={fret} is_new={false} />
                        );
                    })}
                    <div ref={LoadMoreFretsRef} style={{height:'20px'}}/>
                    <input type='button' style={{height:'35px',margin:'auto',marginTop:'0px',color:'white',width:'30%',color:'black',borderRadius:'5px',backgroundColor:'#FFCBCC',border:'none'}} value={'Fermer'} onClick={e=>{close()}} />
                </div>
            </fieldset>);
}

function Delivers() {
    const [delivers,setDelivers] = useState([]);
    const navigator = useNavigate();
    const fetchData = useFetch();
    const [page,setPage] = useState({CurrentPage:1,MaxPage:1});
    const [hasMore,setHasMore] = useState(true);
    const [UserState,setUserState] = useContext(UserContext);

    const FetchDelivers = useCallback(async ()=>{
        if(page.CurrentPage<=page.MaxPage)
        {
            fetchData.PostData({},`delivers/filter/${page.CurrentPage}/`).then((result)=>{
                if(result.result)
                {
                    if(page.CurrentPage>result.maxpage)
                        setHasMore(false);
                    else
                    {setDelivers([...delivers,...result.delivers]);setPage({...page,CurrentPage:page.CurrentPage+1,MaxPage:result.maxpage});}
                }
            })
        }
    },[page.CurrentPage]);

    const LoadMoreRef = useInfiniteScroll(FetchDelivers,hasMore);
    
    useEffect(()=>{
        if(!UserState.is_staff)
            navigator('/');
    },[])

    const LogoDeliver = (part)=>{
        let src = '/images/icons/delivry/delivry.png';
        if(!!part.logo)
            src = MediaUrl(part.logo.image);
        return src;
    }

    const DeleteDeliver = (id)=>{
        fetchData.DeleteData({id:id},'deliver/0/')
    }

  return (
    <div className='partners'>
        <input type='button' onClick={e=>{navigator('/user/deliver/new/')}} className='partners-addbtn' value={'Ajouter un partenaire'} />
        {
            delivers.map((part,index)=>{return(
            <div key={index} className='partners-partner' style={{margin:'5px'}}>
                <img src={LogoDeliver(part)} className='partner-img' />
                <div style={{display:'inline-block',verticalAlign:'middle',maxWidth:'75%',fontSize:'small'}}>
                    <h4 style={{marginBottom:'5px',fontSize:'x-small'}}>{part.title} <Rating initialValue={part.note} style={{marginLeft:'20px'}} size={10} /></h4>
                    <div>
                        <span style={{marginLeft:'20px',color:'gray',fontSize:'xx-small'}}>Telephone : {part.phone}</span>
                    </div>
                    <div>
                        <span style={{marginLeft:'20px',color:'gray',fontSize:'xx-small'}}>Email : {part.email}</span>
                    </div>
            </div>
                    <p style={{color:'GrayText',marginTop:'10px',fontSize:'x-small',display:'block'}}>{part.description}</p>
                    <div style={{marginTop:'10px',width:'100%'}}>
                        <Popup trigger={
                            <button style={{position:'relative',padding:'5px',marginRight:'10px',width:'30px',height:'30px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                                <img src={orders_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                                <span style={{position:'absolute',top:'-5px',right:'-5px',backgroundColor:'black',color:'white',borderRadius:'3px',padding:'3px 5px 3px 5px'}}>{part.colis_counter}</span>
                            </button>}>
                            {close=>(
                                <fieldset style={{position:'fixed',top:'0px',display:'flex',padding:'0px',flexDirection:'column',left:'0px',margin:'auto',backgroundColor:'rgba(255,255,255,0.5)',width:'100%',height:'100vh'}}>
                                    <div style={{margin:'auto',marginTop:'80px',width:'90%'}}>
                                        <DeliverOrders deliver_id={part.id} close={e=>{close()}} />
                                        <input type='button' style={{height:'35px',margin:'auto',marginTop:'10px',color:'black',width:'70%',borderRadius:'5px',backgroundColor:'#FFCCCB',border:'none'}} value={'Fermer'} onClick={e=>{close()}} />
                                    </div>
                                </fieldset>       
                        )}
                        </Popup>
                        <Popup trigger={
                            <button style={{position:'relative',padding:'5px',marginRight:'10px',width:'30px',height:'30px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                                <img src={fret_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                                <span style={{position:'absolute',top:'-5px',right:'-5px',backgroundColor:'black',color:'white',borderRadius:'3px',padding:'3px 5px 3px 5px'}}>{part.frets_counter}</span>
                            </button>}>
                            {close=>(<DeliverFretsPopUp deliver={part} close={()=>{close()}} /> )}
                        </Popup>
                        <button onClick={e=>[DeleteDeliver(part.id)]} style={{position:'relative',padding:'5px',marginRight:'10px',width:'30',height:'30px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                            <img src={remove_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                        </button>
                        <input onClick={e=>{navigator('/user/deliver/'+part.id+'/')}} type='button' style={{border:'none',backgroundColor:'lightgreen',width:'80px',borderRadius:'5px',height:'30px',paddingLeft:'5px',paddingRight:'5px',display:'inline-block',marginTop:'5px',fontSize:'xx-small'}} value={'Voir'} />
                    </div>
            </div>)})
        }
        <div ref={LoadMoreRef} style={{height:'20px'}}/>
    </div>
  )
}

export default Delivers
